/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Spin,
  Row,
  Col,
  Modal,
  message,
} from 'antd';
import { onError, onSuccess } from 'utils/handlers';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import {
  deleteUsuarioAdministrador,
  getUsuariosAdministradores,
  postUsuarioAdministrador,
} from 'api/usuarios/administradores';
import { ActionsNames, isAdmin } from 'utils/permission';

export const tabAdministradoresPermission = {
  model: 'usuario',
};

const Administrators = ({
  disabled,
  usuarios,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getUsuariosAdministradores();
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const _fetchData = async () => {
      setLoading(true);
      const _data = await getUsuariosAdministradores();
      if (mounted) {
        setData(_data);
        setLoading(false);
      }
    };
    _fetchData();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
    setSelectedRowKeys([]);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      if (!data.find((d) => d.email === values.email)) {
        const saved = await postUsuarioAdministrador(values);
        if (saved) {
          onCancel();
          onSuccess({}, 'Agregado exitosamente.');
          await fetchData();
        }
      } else {
        message.info('El Usuario ya es administrador de la entidad');
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => setVisibleAlert(true);

  const deleteItem = async () => {
    setLoading(true);
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteUsuarioAdministrador(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
    setLoading(false);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const rules = { required: [{ required: true }] };

  const columns = [
    {
      titleText: 'Correo',
      key: 'email',
      dataIndex: 'email',
      width: 300,
    },
    {
      titleText: 'Nombre',
      key: 'first_name',
      dataIndex: 'first_name',
      width: 150,
    },
    {
      titleText: 'Apellido',
      key: 'last_name',
      dataIndex: 'last_name',
      width: 150,
    },
  ];

  const _isAdmin = isAdmin();

  return (
    <Spin tip="Cargando..." spinning={loading}>
      <Table
        cols={columns}
        data={data}
        rowSelection={rowSelection}
        handleOnRowClick={handleOnRowClick}
        controls={{
          onClickAdd,
          onClickDelete,
        }}
        allowEdit={false}
        allowExport={false}
        allowSort={false}
        allowSearch={false}
        disabled={disabled}
        rowKey="id"
        permission={{
          [ActionsNames.view]: _isAdmin,
          [ActionsNames.add]: _isAdmin,
          [ActionsNames.delete]: _isAdmin,
          hasAllViewPermission: _isAdmin,
        }}
        allowExportPDF={false}
      />
      <Modal
        open={open}
        closable={false}
        footer={null}
        title={(
          <Row justify="space-between">
            {`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Administrador`}
            <FormSubmitControls
              onFinish={onFinish}
              onCancel={onCancel}
            />
          </Row>
        )}
        onCancel={onCancel}
        forceRender
      >
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            <Col span={24}>
              <Form.Item
                name="email"
                label="Correo"
                rules={rules.required}
              >
                <Select
                  dataSource={usuarios}
                  valueProp="email"
                  labelProp="email"
                  keyProp="id"
                  render={(item) => item.email}
                />
              </Form.Item>
            </Col>
            <Col span={0}>
              <Form.Item>
                <Button htmlType="submit" />
              </Form.Item>
            </Col>
          </Form>
        </Col>
      </Modal>
      <ModalDelete
        onDelete={deleteItem}
        onCancel={() => {
          setVisibleAlert(false);
          setSelectedRowKeys([]);
        }}
        open={visibleAlert}
        content={`al Administrador ${form.getFieldValue('first_name')} ${form.getFieldValue('last_name') || ''}`}
      />
    </Spin>
  );
};

Administrators.propTypes = {
  disabled: PropTypes.bool,
  permission: PropTypes.shape({}).isRequired,
  usuarios: PropTypes.arrayOf(PropTypes.object),
};

Administrators.defaultProps = {
  disabled: false,
  usuarios: [],
};

export default Administrators;
